<template>
    <div>
        <o-header v-if="isVisibleOnSmallScreens"/>
        <div :class="{'application' : true, 'sidebar-menu-opened' : sidebar_is_opened}">
            <div class="sidebar">
                <sidebar />
                <sidebar-secondary />
            </div>
            <div v-if="isVisibleOnSmallScreens" class="section content-wrapper">
                <div class="container is-fluid">
                    <div class="columns">
                        <div class="column is-12 content-area is-paddingless">
                          <div>
                            <router-view v-slot="{ Component }">
                              <component :is="Component" :key="routeKey" />
                            </router-view>
                          </div>

                            <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" @close="closeModal" v-model:active="isTimelogActive" has-modal-card>
                                <timelog-modal
                                    :timelog-prop="{project_id: globalTimelogProjectId, activity_type: globalTimelogActivityType, activity_id: globalTimelogActivityId, is_forced: isGlobalTimelogShort}"
                                    :closable="isGlobalTimelogClosable"
                                    :isShort="isGlobalTimelogShort"
                                    :autoFill="isGlobalTimelogAutoFill"
                                />
                            </o-modal>

                            <o-modal scroll="keep" @close="closeModal" v-model:active="isMessageModalActive" has-modal-card :can-cancel="messageModal.closable!==false">
                                <message
                                    :entity="messageModal.entity"
                                    :entity-type="messageModal.entity_type"
                                    :context="messageModal.context"
                                    :is-reminder="messageModal.isReminder"
                                    :closable="messageModal.closable === false ? false : true"
                                    :loc-service="messageModal.locService"
                                />
                            </o-modal>

                            <o-footer />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import OHeader from '../components/Header'
    import Sidebar from '../components/Sidebar'
    import SidebarSecondary from '../components/SidebarSecondary'
    import OFooter from '../components/Footer'
    import TimelogModal from './../components/modals/TimeLog'
    import Message from './../components/modals/Message'

    import SmallScreensConfirmationMixin from '../mixins/SmallScreensConfirmation.js'

    export default {
        mixins: [SmallScreensConfirmationMixin],

        components: { OHeader, Sidebar, SidebarSecondary, OFooter, TimelogModal, Message },

        mounted () {
            this.fetchUnreadLatest5Notifications()
        },
        watch: {
            $route (to, from){
                
            }
        },

        methods: {
            ...mapActions([
                'fetchUnreadLatest5Notifications',
                'closeGlobalTimelog',
                'closeMessageModal',
                'setForceRouteKey'
            ]),

            closeModal() {
              return this.$parent.$parent.$emit('update:active', false) || this.$parent.$emit('update:active', false) || this.$emit('update:active', false)
            },
        },

        computed: {
            ...mapGetters([
                'sidebar_is_opened',
                'currentUserId',
                'globalTimelogProjectId',
                'isGlobalTimelogActive',
                'isGlobalTimelogClosable',
                'isGlobalTimelogShort',
                'isGlobalTimelogAutoFill',
                'globalTimelogActivityType',
                'globalTimelogActivityId',
                'messageModal',
                'isRouteKeyForced'
            ]),

            routeKey() {
                if(this.isRouteKeyForced) {
                    this.setForceRouteKey(false)
                    return this.$route.fullPath
                }
                // https://app.mayvendev.com/p/ordino/tasks/616
                // without it project wont change properly from any project links on projects.swho
                return _.startsWith(this.$route.name, 'projects.') ?
                    `project-${this.$route.params.slug}` :
                    null
            },

            // sidebarIsOpened () {
            //     return this.sidebar_is_opened()
            // },

            isTimelogActive: {
                get() {
                    return this.isGlobalTimelogActive
                },
                set() {
                    this.closeGlobalTimelog()
                }
            },

            isMessageModalActive: {
                get() {
                    return this.messageModal.active
                },
                set() {
                    this.closeMessageModal()
                }
            }
        },

        // unmounted() {
        //   this.$.appContext.app.unmount();
        // }
    }
</script>
